/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamRolePermission,
    IamRolePermissionFromJSON,
    IamRolePermissionFromJSONTyped,
    IamRolePermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateIamRolePermissionResponse
 */
export interface CreateIamRolePermissionResponse {
    /**
     * 
     * @type {IamRolePermission}
     * @memberof CreateIamRolePermissionResponse
     */
    iamRolePermission: IamRolePermission;
}

export function CreateIamRolePermissionResponseFromJSON(json: any): CreateIamRolePermissionResponse {
    return CreateIamRolePermissionResponseFromJSONTyped(json, false);
}

export function CreateIamRolePermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamRolePermissionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRolePermission': IamRolePermissionFromJSON(json['iam_role_permission']),
    };
}

export function CreateIamRolePermissionResponseToJSON(value?: CreateIamRolePermissionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_role_permission': IamRolePermissionToJSON(value.iamRolePermission),
    };
}


